!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ne = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ne",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var r = String(e).split("."),
          a = Number(r[0]) == e;
      return t ? a && e >= 1 && e <= 4 ? "one" : "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "वर्ष",
        relative: {
          0: "यो वर्ष",
          1: "आगामी वर्ष",
          "-1": "गत वर्ष"
        },
        relativeTime: {
          future: {
            one: "{0} वर्षमा",
            other: "{0} वर्षमा"
          },
          past: {
            one: "{0} वर्ष अघि",
            other: "{0} वर्ष अघि"
          }
        }
      },
      "year-short": {
        displayName: "वर्ष",
        relative: {
          0: "यो वर्ष",
          1: "आगामी वर्ष",
          "-1": "गत वर्ष"
        },
        relativeTime: {
          future: {
            one: "{0} वर्षमा",
            other: "{0} वर्षमा"
          },
          past: {
            one: "{0} वर्ष अघि",
            other: "{0} वर्ष अघि"
          }
        }
      },
      month: {
        displayName: "महिना",
        relative: {
          0: "यो महिना",
          1: "अर्को महिना",
          "-1": "गत महिना"
        },
        relativeTime: {
          future: {
            one: "{0} महिनामा",
            other: "{0} महिनामा"
          },
          past: {
            one: "{0} महिना पहिले",
            other: "{0} महिना पहिले"
          }
        }
      },
      "month-short": {
        displayName: "महिना",
        relative: {
          0: "यो महिना",
          1: "अर्को महिना",
          "-1": "गत महिना"
        },
        relativeTime: {
          future: {
            one: "{0} महिनामा",
            other: "{0} महिनामा"
          },
          past: {
            one: "{0} महिना पहिले",
            other: "{0} महिना पहिले"
          }
        }
      },
      day: {
        displayName: "बार",
        relative: {
          0: "आज",
          1: "भोलि",
          2: "पर्सि",
          "-2": "अस्ति",
          "-1": "हिजो"
        },
        relativeTime: {
          future: {
            one: "{0} दिनमा",
            other: "{0} दिनमा"
          },
          past: {
            one: "{0} दिन पहिले",
            other: "{0} दिन पहिले"
          }
        }
      },
      "day-short": {
        displayName: "बार",
        relative: {
          0: "आज",
          1: "भोलि",
          2: "पर्सि",
          "-2": "अस्ति",
          "-1": "हिजो"
        },
        relativeTime: {
          future: {
            one: "{0} दिनमा",
            other: "{0} दिनमा"
          },
          past: {
            one: "{0} दिन पहिले",
            other: "{0} दिन पहिले"
          }
        }
      },
      hour: {
        displayName: "घण्टा",
        relative: {
          0: "यस घडीमा"
        },
        relativeTime: {
          future: {
            one: "{0} घण्टामा",
            other: "{0} घण्टामा"
          },
          past: {
            one: "{0} घण्टा पहिले",
            other: "{0} घण्टा पहिले"
          }
        }
      },
      "hour-short": {
        displayName: "घण्टा",
        relative: {
          0: "यस घडीमा"
        },
        relativeTime: {
          future: {
            one: "{0} घण्टामा",
            other: "{0} घण्टामा"
          },
          past: {
            one: "{0} घण्टा पहिले",
            other: "{0} घण्टा पहिले"
          }
        }
      },
      minute: {
        displayName: "मिनेट",
        relative: {
          0: "यही मिनेटमा"
        },
        relativeTime: {
          future: {
            one: "{0} मिनेटमा",
            other: "{0} मिनेटमा"
          },
          past: {
            one: "{0} मिनेट पहिले",
            other: "{0} मिनेट पहिले"
          }
        }
      },
      "minute-short": {
        displayName: "मिनेट",
        relative: {
          0: "यही मिनेटमा"
        },
        relativeTime: {
          future: {
            one: "{0} मिनेटमा",
            other: "{0} मिनेटमा"
          },
          past: {
            one: "{0} मिनेट पहिले",
            other: "{0} मिनेट पहिले"
          }
        }
      },
      second: {
        displayName: "सेकेन्ड",
        relative: {
          0: "अहिले"
        },
        relativeTime: {
          future: {
            one: "{0} सेकेन्डमा",
            other: "{0} सेकेन्डमा"
          },
          past: {
            one: "{0} सेकेन्ड पहिले",
            other: "{0} सेकेन्ड पहिले"
          }
        }
      },
      "second-short": {
        displayName: "सेकेन्ड",
        relative: {
          0: "अहिले"
        },
        relativeTime: {
          future: {
            one: "{0} सेकेन्डमा",
            other: "{0} सेकेन्डमा"
          },
          past: {
            one: "{0} सेकेन्ड पहिले",
            other: "{0} सेकेन्ड पहिले"
          }
        }
      }
    }
  }, {
    locale: "ne-IN",
    parentLocale: "ne"
  }];
});